import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.423}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16000 26661"
    {...props}
  >
    <path
      d="M15421 12290c0 3172-4179 3424-4492 5835h-612c936-13284 907-12842 905-12886-7-232-267-356-452-229-44 30 209-153-814 590l-808-587c-101-74-238-74-340 0l-808 587-808-587c-101-74-238-74-340 0l-808 587c-847-615-826-608-889-628-209-60-383 98-378 284 2 43-64-901 906 12869h-612c-312-2408-4492-2666-4492-5835V4386c0-2099 1708-3807 3807-3807h7228c2099 0 3807 1708 3807 3807v7904zm-8456-488v6323h-701L5515 7490l1450 4312zm1572-337H7463L5630 6016l243 176c102 74 240 74 341 1l808-587 808 587c101 73 239 73 340 0l808-587 808 587c102 73 239 73 341-1l243-176-1833 5449zm-992 580h911v6079h-911v-6079zm1490 6080v-6323l1450-4312-749 10635h-701zm-3945 1586v-1006h5820v1006H5090zm5820 1585H5090v-1005h5820v1005zm0 1585H5090v-1005h5820v1005zm-970 1586H6060c-505 0-970-394-970-1006h5820c0 607-460 1006-970 1006zm-1290 1615H7350l-429-1036h2158l-429 1036zM11614 0H4386C1967 0 0 1968 0 4386v7904c0 3616 4510 3919 4510 6125v1296h-183c-160 0-290 129-290 289 0 161 130 291 290 291h183v1005h-183c-160 0-290 130-290 290s130 290 290 290h183v1005h-183c-160 0-290 130-290 291 0 160 130 289 290 289h183c0 945 738 1585 1550 1585h233l596 1437c45 108 150 178 268 178h1687c117 0 222-70 267-178l596-1437h233c810 0 1550-637 1550-1585h183c160 0 290-129 290-289 0-161-130-291-290-291h-183v-1005h183c160 0 290-130 290-290s-130-290-290-290h-183v-1005h183c160 0 290-130 290-291 0-160-130-289-290-289h-183v-1294c0-2213 4510-2507 4510-6127V4386c0-2419-1967-4386-4386-4386z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
